<template>
<div>
<!--  产品订购-->
  <a-modal width="1250px"
           :dialogStyle="{ 'top': '5%',}"
           v-model="visible"
           :footer="null"
           @cancel="handleClose">
    <template slot="title">
      <span style="font-weight: 550;color: #333333;font-size: 20px">产品订购</span>
    </template>
    <div style="margin-bottom: 80px">
      <div class="ProductOrdering-title">
        <div>购买须知 <a class="ExampleEffect">示例效果</a></div>
      </div>
      <div class="notice">
        1、须知内容运营后台编辑
        2、须知内容运营后台编辑
        3、须知内容运营后台编辑
      </div>
      <div class="ProductOrdering-title">选择配置</div>
      <div style="display: flex;margin-bottom: 30px;align-items: center">
        <div style="width: 100px">套餐类型</div>
        <div><a-radio-group v-model="TypePackage" @change="onChange">
          <a-radio-button value="a" style="width: 120px;text-align: center">
            自定义套餐包
          </a-radio-button>
          <a-radio-button value="b" style="width: 120px;text-align: center">
            固定套餐
          </a-radio-button>
          <a-radio-button value="c" style="width: 120px;text-align: center">
            永久购买
          </a-radio-button>
        </a-radio-group></div>
      </div>
      <div style="display: flex;align-items: center;margin-bottom: 30px" v-if="TypePackage === 'a'">
        <div style="width: 100px">套餐包内容</div>
        <div style="display: flex">
          <div v-for="(item,index) in PackageContent" :key="index">
            <div class="PackageContent-col">
              <div style="color: #333333">{{item.name}}</div>
              <div style="color: #FF6800">{{item.money}}</div>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex;align-items: center;margin-bottom: 30px" v-if="TypePackage === 'a' || TypePackage === 'b'">
        <div style="width: 100px">购买数量</div>
        <div>
          <div style="display: flex;align-items: center">
            <a-button style="border-radius: unset" :disabled="number === 1">-</a-button>
            <div class="inputDiv">{{number}}</div>
            <a-button style="border-radius: unset">+</a-button>
          </div>
        </div>
      </div>
      <div style="display: flex;margin-bottom: 30px;">
        <div style="width: 100px;padding-top: 5px">有效期</div>
        <div>
          <div class="btn">
            <span v-if="TypePackage !== 'c'">24个月</span>
            <span v-else>永久</span>
          </div>
          <div style="font-size: 12px;color: #bdbdbd;margin-top: 5px">
            <span v-if="TypePackage !== 'c'">自购买之日起24个月内有效，过期销毁资源，不支持延期和退款</span>
            <span v-else>自购买之日起永久有效，支付成功24小时后不支持退款</span>
          </div>
        </div>
      </div>
    </div>
    <div
        :style="{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            display:'flex',
            justifyContent:'right',
            alignItems:'center',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1,
          }"
    >
      <div class="btn-left">
        <div>总费用<span style="font-size: 16px;color: #00C024">￥ <span style="font-size: 18px">100</span></span></div>
        <div class="yMoney">￥299</div>
      </div>
      <a-button style="margin-left: 15px" type="primary" @click="weaponeeringBtn">
        确定使用
      </a-button>
    </div>
  </a-modal>
</div>
</template>

<script>
export default {
name: "ProductOrdering",
  props:{
    visible:{
      type:Boolean
    }
  },
  data(){
  return{
    number:1,
    TypePackage:'a',
    PackageContent:[
      {
        name:'100条',
        money:'0.05元/条'
      },{
        name:'500条',
        money:'0.05元/条'
      },{
        name:'1000条',
        money:'0.05元/条'
      },
    ]
  }
  },
  methods:{
    handleClose(){
      let visible = false;
      this.$emit("closeProductOrdering", visible); //子组件向父组件传值（开关）
    },
    weaponeeringBtn(){

    },
    onChange(){
      console.log(this.TypePackage)
    },
  }
}
</script>

<style scoped lang="scss">
.ProductOrdering-title{
  height: 25px;
  line-height: 25px;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  border-left: 5px solid #1890FF;
  padding-left: 10px;
  margin-bottom: 20px;
  .ExampleEffect{
    margin-left: 10px;
    font-size: 14px;
    font-weight: 400;
  }
}
.notice{
  margin: 20px 0;
}
.PackageContent-col{
  display: flex;
  justify-content: space-around;
  border: 1px solid #D9D9D9;
  width: 150px;
  height: 35px;
  line-height: 35px;
  margin-right: 10px;
}
.PackageContent-col-hover{
  display: flex;
  justify-content: space-around;
  border: 1px solid #D9D9D9;
  width: 150px;
  height: 35px;
  line-height: 35px;
  margin-left: 10px;
  box-shadow: 0 0 5px rgba(0,0,0,.2);
}
.inputDiv{
  border-top: 1px solid #D9D9D9;border-bottom: 1px solid #D9D9D9;
  height: 32px;
  line-height: 32px;
  width: 50px;
  text-align: center;
}
.btn{
  width: 150px;
  text-align: center;
  height: 35px;
  line-height: 35px;
  background-color: #0052D9;
  color: white;
}
.yMoney{
  text-decoration: line-through;
  color: #929292;
}
.btn-left{
  font-size: 12px;color: #333333;margin-right: 10px;
}
</style>
